export default {
    computed: {
        shareUrl () {
            return new URL(this.$router.options.base, window.location.origin);
        },
    },
    methods: {
        shareFacebook (url) {
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, 'share_facebook', 'width=420,height=400');
        },
        shareTwitter (url) {
            window.open(`https://twitter.com/intent/tweet?url=${url}`, 'share_twitter', 'width=420,height=400');
        },
    },
};
